import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";
import { OUTCOMES, PLATFORM, exploreLink } from "./siteNav";
import { ease } from "./kit";

export function MegaTrigger({ open, onToggle, onOpen, active }) {
  return (
    <button type="button" onClick={onToggle} onMouseEnter={onOpen} aria-haspopup="true" aria-expanded={open} data-testid="site-nav-product"
      className={`flex items-center gap-1 text-[13px] font-medium transition-colors ${open || active ? "text-white" : "text-zinc-400 hover:text-white"}`}>
      Product <ChevronDown size={13} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
    </button>
  );
}

export function MegaPanel({ onClose }) {
  return (
    <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.22, ease }} className="absolute inset-x-0 top-full z-40 border-b border-white/10 bg-[#0A0A0B] shadow-[0_40px_80px_-30px_rgba(0,0,0,.8)]" data-testid="mega-menu">
      <div className="wrap grid lg:grid-cols-12">
        <div className="grid grid-cols-3 gap-x-8 gap-y-8 py-8 lg:col-span-9 lg:border-r lg:border-white/10 lg:pr-10">
          {OUTCOMES.map((o, i) => (
            <div key={o.key} data-testid={`mega-outcome-${o.key}`}>
              <Link to={exploreLink(o.key)} onClick={onClose} className="group flex items-start gap-3" data-testid={`mega-outcome-link-${o.key}`}>
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center border border-white/15 text-amber-500 transition-colors group-hover:border-amber-500/60"><o.icon size={14} /></span>
                <span className="min-w-0"><span className="flex items-baseline gap-2"><span className="font-mono text-[10px] tracking-[.14em] text-zinc-600">{String(i + 1).padStart(2, "0")}</span><span className="display text-[15px] text-white transition-colors group-hover:text-amber-400">{o.label}</span></span><span className="block text-[12px] text-zinc-500">{o.short}</span></span>
              </Link>
              <ul className="mt-3 space-y-1.5 pl-11">{o.features.slice(0, 4).map(([f]) => <li key={f}><Link to={o.anchor} onClick={onClose} className="text-[12.5px] text-zinc-400 transition-colors hover:text-white">{f}</Link></li>)}</ul>
            </div>
          ))}
        </div>
        <div className="py-8 lg:col-span-3 lg:pl-10">
          <div className="mono-label">Platform</div>
          <ul className="mt-4 divide-y divide-white/10 border-y border-white/10">
            {PLATFORM.map(([t, c, to, I]) => <li key={t}><Link to={to} onClick={onClose} className="group flex items-start gap-3 py-3" data-testid={`mega-platform-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}><I size={14} className="mt-0.5 shrink-0 text-zinc-500 transition-colors group-hover:text-amber-500" /><span><span className="block text-[13px] font-medium text-white">{t}</span><span className="block text-[11.5px] leading-snug text-zinc-500">{c}</span></span></Link></li>)}
          </ul>
          <Link to={exploreLink("run")} onClick={onClose} className="mt-6 block border border-amber-500/40 bg-amber-500/[.06] p-4 transition-colors hover:bg-amber-500/[.12]" data-testid="mega-deal-callout">
            <span className="mono-label amber">New</span>
            <span className="display mt-1.5 block text-[15px] text-white">Deal · A to Z</span>
            <span className="block text-[12px] leading-snug text-zinc-400">Enquiry → Quote → Job → Invoice → Paid. One record, one screen, always the next action.</span>
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap flex items-center justify-between gap-4 py-3 text-[12.5px]">
          <Link to="/product" onClick={onClose} className="site-link !text-[12.5px]" data-testid="mega-all-modules">All 14 modules <ArrowRight size={13} /></Link>
          <span className="hidden text-zinc-500 md:block">One record for the office, the field and the customer.</span>
          <Link to="/book-demo" onClick={onClose} className="font-medium text-zinc-300 transition-colors hover:text-white">Book a demo →</Link>
        </div>
      </div>
    </motion.div>
  );
}

export function MobileOutcomes({ onClose }) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 border-t border-white/10 py-4 pl-[52px]" data-testid="site-mnav-outcomes">
      {OUTCOMES.map((o) => <Link key={o.key} to={exploreLink(o.key)} onClick={onClose} className="flex items-center gap-2 text-[13px] text-zinc-400 transition-colors hover:text-white" data-testid={`site-mnav-outcome-${o.key}`}><o.icon size={12} className="shrink-0 text-amber-500" />{o.label}</Link>)}
    </div>
  );
}
